import { render } from "./PolicyOwnershipTab.vue?vue&type=template&id=60e2113f&scoped=true&ts=true"
import script from "./PolicyOwnershipTab.vue?vue&type=script&lang=ts"
export * from "./PolicyOwnershipTab.vue?vue&type=script&lang=ts"

import "./PolicyOwnershipTab.vue?vue&type=style&index=0&id=60e2113f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e2113f"]])

export default __exports__